/**
 * Hook für die Übersichtsseite
 * Lädt Projekte und KPIs vom Backend
 */
import { useState, useCallback, useEffect } from "react";
import { ProjectOverviewItem, KPIData } from "../../../../types";
import { apiService } from "../../../../services/api";
import { parseApiError } from "../../../../services/api/errorPresentation";

export function useOverviewData() {
  const [projects, setProjects] = useState<ProjectOverviewItem[]>([]);
  const [kpis, setKpis] = useState<KPIData>({
    anzahlProjekte: 0,
    durchschnittlicherIRR: null,
    durchschnittlicheEkQuote: null,
    wirtschaftlichkeitErklaerung: "",
    reifegradErklaerung: "",
    reifegradGewichte: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const overviewResult = await apiService.getProjectsOverview();
      setProjects(overviewResult.projects);
      setKpis(overviewResult.kpis);
    } catch (err) {
      setError(parseApiError(err).message);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const removeProject = useCallback((projectId: string) => {
    setProjects((prev) => prev.filter((p) => p.id !== projectId));
  }, []);

  return {
    projects,
    kpis,
    loading,
    error,
    reload: loadData,
    removeProject,
  };
}
